<template>
  <div class="am-welcome container">
      <header>
        <h3>Welcome To Agency Matrix {{ currentStats.currentVersion }}</h3>
      </header>
      <!-- Welcome Screen Customized for Version 7.7, DIV and "v-if" shall be removed after we have release notes for 7.7 -->
<!--      <div v-if="!isLoading && currentStats.currentVersion === 'v7.7'" class="am-content row">-->
<!--        <div :class="{'col-sm-6': currentStats.video.code, 'col-sm-12': !currentStats.video.code }">-->
<!--          <h4>New Features</h4>-->
<!--          <em class="am-welcome77">Coming Soon...</em><br>-->
<!--        </div>-->
<!--      </div>-->
      <!-- Welcome Screen Customized DIV End -->
      <div v-if="!isLoading && currentStats.currentVersion === 'v7.7'" class="am-content row">
          <div :class="{'col-sm-6': currentStats.video.code, 'col-sm-12': !currentStats.video.code }">
            <h4>New Features</h4>
            <ul>
              <li v-for="item in currentStats.features" v-bind:key="item.title">{{ item.title }}</li>
            </ul>
            <a class="am-releaseNote" :href="releaseNotes" target="_blank">Click Here to Download the Release Notes</a>          </div>
          <div class="col-sm-6 am-video" v-if="currentStats.video.code">
            <iframe v-bind:src="getVideoSource()" class="video" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
          </div>
      </div>
      <div v-if="isLoading" class="am-content row center">
        <div class="col-12">
          <h3>Please Wait</h3>
          <p>We are doing some quick prep work. This shouldn't take more than a moment.</p>
        </div>
      </div>
      <footer>
       <br><div><button v-if="!this.isLoading" @click="onNext()" class="btn-success">Next</button></div>
      </footer>
    </div>
</template>

<script>
import api from '@/http'
import config from '@/config/global.config'

export default {
  name: 'Welcome',
  data: function () {
    return {
      isLoading: false,
      showVideo: true,
      showTerms: false,
      isTermChecked: false,
      isButtonDisabled: true,
      currentStats: {
        currentVersion: 'v7.7',
        video: {
          type: 'vimeo',
          code: '420355689'
        },
        features: [
          {
            title: ' Improved Interface'
          },
          {
            title: 'Enhanced Premium Finance'
          },
          {
            title: 'Expanded Rater Integration'
          },
          {
            title: 'Bank Deposit & Reconciliation Improvements'
          },
          {
            title: 'New Marketing Bridge'
          },
          {
            title: 'Petty Cash Tracking'
          },
          {
            title: 'Enhanced Clock-In & Clock-Out'
          }
        ]
      }
    }
  },
  computed: {
    releaseNotes: function () {
      return config.applicationUrl('/upload/release-notes/v7.7 Release Notes.pdf')
    }
  },
  methods: {
    forceReload () {
      if (!window.fetch) {
        return
      }

      var els = document.getElementsByTagName('*')
      for (var i = 0; i < els.length; i++) {
        var src = ''
        if (els[i].tagName === 'A') {
          continue
        }

        if (!src && els[i].src) {
          src = els[i].getAttribute('src')
        }

        if (!src && els[i].href) {
          src = els[i].getAttribute('href')
        }

        if (!src) {
          continue
        }

        fetch(src, { cache: 'reload' })
      }
    },
    onNext () {
      this.isLoading = true
      let self = this
      if(this.isTermChecked){
        self.showTerms = false
      }
      api.makeRequest('/welcome/update-version/').then(function (data) {
        self.forceReload()

        let redirectUrl = data.data.redirect || false
        if (typeof redirectUrl === 'undefined' || !redirectUrl) {
          redirectUrl = config.applicationUrl('/#/home')
        }

        window.location = redirectUrl
      })
    },
    getVideoSource () {
      return (this.currentStats.video.type !== 'vimeo' ? '//www.youtube.com/embed/' : '//player.vimeo.com/video/') + this.currentStats.video.code
    },

    isButtonActive () {
      this.isButtonDisabled = (!this.isTermChecked && this.showTerms) ? (!this.isTermChecked && this.showTerms) : false
      return this
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~@/assets/scss/variables';

  .am-welcome {
    width: 100%;
    height: 100%;
    background-color: $backgroundColor;

    &.container {
      padding: 0;
    }

    header {
      background-color: $primaryColor;
      padding: 10px;
      color: $headerColor;
      text: {
        align: center;
      }
      h3{
        font-size: 1rem;
        color: $headerColor ;
      }
    }



    .am-content {
      padding: 30px;
      height: 75%;

      .am-video {
        iframe {
          width: 100%;
          height: 100%;
        }
      }
      ul {
        list-style: none;
      }
      li {
        font-size: 0.8rem;
      }
      ul li:before {
        content: "•";
        font-size: 150%;
        padding-right: 5px;
      }
      .am-releaseNote {
        font-size: 0.8rem;
      }
    }
    .am-welcome77
    {
      font-size: 14px;
    }

    footer {
      text: {
        align: center;
      }

      button {
        padding: 5px 100px;
      }

      button:disabled,
      button[disabled]{
        border: 1px solid #999999;
        background-color: #cccccc !important;
        color: #666666 !important;
      }
    }
  }
</style>

<style>
  @media screen and (orientation:landscape) {
    .am-vue-modal-responsive-screen {
      top: 0 !important;
    }
  }
  @media screen and (orientation:portrait) {
    .am-vue-modal-responsive-screen {
      top: 0 !important;
    }
  }
</style>
